exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/app/routes/restaurant/users/view-user/view-users.component.scss
// module id = ../../../../../src/app/routes/restaurant/users/view-user/view-users.component.scss
// module chunks = main